import dicomRTAnnotationExport from './dicomRTAnnotationExport';

export default dicomRTAnnotationExport;
